import {isNil} from 'lodash';
import {useRouter} from 'next/router';
import {useCallback, useEffect} from 'react';
import {TrackPageViewContainer} from '../../../common/containers/TrackPageViewContainer';
import {requestContext} from '../../../common/requestContext';
import useTypedDispatch from '../../../common/useTypedDispatch';
import useTypedSelector from '../../../common/useTypedSelector';
import {LOCAL_STORAGE_NOTICE_LAST_ADDED_DATE_KEY} from '../../../config/constants';
import {NoticeProps} from '../../../design-system/pages/Notice/NoticeProps.interface';
import {NoticeQueryType} from '../../../design-system/pages/Notice/NoticeQueryType.enum';
import {ProfileMenuId} from '../../../profileMenu/constants';
import {setIsUpdated} from '../../../profileMenu/profileMenuSlice';
import {useLogin} from '../../../user/useLogin.hook';
import {useAppConfigQuery} from '../../../wrapper';
import {NoticeFetcherHeadless} from '../headless/NoticeFetcherHeadless';
import {getNoticeUrl} from '../util/getNoticeUrl';

interface NoticeContainerProps {
  children: (props: NoticeProps) => React.ReactNode;
}

export const NoticeContainer = ({children}: NoticeContainerProps) => {
  const {isMobile, isWebView} = requestContext.requestInfo.display;
  const {noticeData, noticeId, noticePage} = useTypedSelector(
    state => state.notice
  );
  const result = useAppConfigQuery();
  const noticeLastAddedDate =
    result.data?.appConfig?.appBadge?.noticeLastAddedDate;
  const dispatch = useTypedDispatch();
  const {isLogin} = useLogin();

  const router = useRouter();
  const routeToNoticeUrl = useCallback(
    (queryType: NoticeQueryType, queryValue: number | string) => {
      router.push(getNoticeUrl(queryType, queryValue), undefined, {
        scroll: false,
      });
    },
    [router]
  );

  useEffect(() => {
    if (isLogin && noticeLastAddedDate) {
      // 공지사항 페이지 진입 시 로컬 스토리지의 noticeLastUpdatedDate 정보 갱신
      window.localStorage.setItem(
        LOCAL_STORAGE_NOTICE_LAST_ADDED_DATE_KEY,
        noticeLastAddedDate
      );
      dispatch(
        setIsUpdated({
          menuId: ProfileMenuId.Notice,
          isUpdated: false,
        })
      );
    }
  }, [dispatch, isLogin, noticeLastAddedDate]);

  return (
    <>
      <NoticeFetcherHeadless>
        {children({
          isWebView,
          isMobile,
          noticeData,
          noticeId,
          noticePage,
          routeToNoticeUrl,
        })}
        {!isNil(noticeId) && (
          <TrackPageViewContainer
            trackObj={{
              section: '더보기',
              page: '공지사항',
              actionType: 'Pageview',
              actionName: '공지사항_화면',
              customProps: {user_action: 'pv'},
            }}
          />
        )}
      </NoticeFetcherHeadless>
    </>
  );
};
